import { marshal, Nullable } from "@gsx/common";
import { injectable } from "inversify";
import { Api } from "../../../../../common/src/api/Api";
import { SubmitStore } from "../../../../../common/src/stores/general/SubmitStore";
import { ReportBody } from "@gsx/common/src/types/http/admin/report";
import { createReportEmptyBody } from "../../../utility/entity/report";

@injectable()
export class ReportCreateStore extends SubmitStore<ReportBody> {
    readonly data: Nullable<ReportBody> = createReportEmptyBody();
    reportMedia: FormData = new FormData();

    constructor(private readonly api: Api) {
        super();
    }

    protected async request(): Promise<void> {
        const body = marshal(this.data);
        await this.api.admin.reports.create(body, this.reportMedia);
    }
}
